import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackEvent } from '../services/track';
import { hasConsent } from './CookieConsent';

const RouteTracker = () => {
  const location = useLocation();

  useEffect(() => {
    if (!hasConsent()) return;
    try {
      trackEvent({
        type: 'page_view',
        url: window.location.href,
        referrer: document.referrer || null,
        user_agent: navigator.userAgent,
        screen: { w: window.innerWidth, h: window.innerHeight },
        tz: Intl.DateTimeFormat().resolvedOptions().timeZone,
        session_id: window.sessionStorage.getItem('padaid_session') || undefined,
        anonymous_id: window.localStorage.getItem('padaid_anonymous') || undefined,
      });
    } catch (e) {}
  }, [location.pathname, location.search]);

  useEffect(() => {
    // init ids
    try {
      if (!window.localStorage.getItem('padaid_anonymous')) {
        window.localStorage.setItem('padaid_anonymous', Math.random().toString(36).slice(2));
      }
      if (!window.sessionStorage.getItem('padaid_session')) {
        window.sessionStorage.setItem('padaid_session', Math.random().toString(36).slice(2));
      }
    } catch (e) {}
  }, []);

  return null;
};

export default RouteTracker;